import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

export const animation = gsap.to('.header', {
  y: '-100%',
  paused: true,
  duration: 0.2
});

export function toggleTopbar() {
  ScrollTrigger.create({
    trigger: "body",
    start: 'top top',
    onUpdate: self => {
      const navbar = document.querySelector('.navbar-collapse')
      if (!navbar.classList.contains('show') && !navbar.classList.contains('collapsing')) {
        self.direction === 1 ? animation.play() : animation.reverse()
      }
    },
  })
}
